import { render, staticRenderFns } from "./SelecionarCar.vue?vue&type=template&id=560221e0&scoped=true&lang=pug"
import script from "./SelecionarCar.vue?vue&type=script&lang=js"
export * from "./SelecionarCar.vue?vue&type=script&lang=js"
import style0 from "./SelecionarCar.vue?vue&type=style&index=0&id=560221e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560221e0",
  null
  
)

export default component.exports